import React from 'react';
import {
    Show,
    TextField,
    SelectField,
    CardActions,
    EditButton,
    FunctionField
} from 'react-admin';
import {
    Card,
    CardContent,
    Typography
} from '@material-ui/core';

import streetTypes from "../helper/StreetTypes";
import PhoneArrayField from "../component/PhoneArrayField";

import "./styles/main.css"

const DivisionShowTitle = ({ record }) => {
    return <span>Мої аптеки: {record ? `"${record.name}"` : ''}</span>;
};

const Label = (prop) => {
    return (
        <span style={labelStyle}>{prop.caption}: </span>
    );
}

const cardStyle = {
    width: "100%",
    margin: '0.5em',
    padding: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top',
    fontSize: '1.25rem',
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    fontWeight: 500,
    lineHeight: '1.6',
    letterSpacing: '0.0075em'
};
const rowStyle = {
    margin: '0',
    lineHeight: '30px',
    padding: "3px 0",
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
};
const labelStyle = {
    display: 'inline-block',
    width: 200,
    fontSize: '1rem',
    fontWeight: 500,
    fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
    color: 'gray'
};

const DivisionActions = ({ data }) => (
    <CardActions>
        <EditButton record={data} label={"Редагувати"} />
    </CardActions>
);

const getAllTimeHours = (timeRange) => {
    if (timeRange.length) {
        return timeRange.map((item) => `  ${item.start} - ${item.end}`).join(";");
    } else {
        return ""
    }
}

const getAllTimeHoursWeekEnd = (timeRange) => {
    let result = "";

    if (timeRange[0]?.start) {
        result = timeRange.map((item) => `  ${item.start} - ${item.end}`).join(";")
    } else result = 'Вихідний';

    return result;
}

const DivisionShow = (props) => {
    return (
        <Show className="show-styles" {...props} title={<DivisionShowTitle/>} actions={<DivisionActions />}>
            <div style={{ margin: '1em' }}>
                <div className="legal-entity-list-show">
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Загальна інформація</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Назва Аптеки"}/>
                            <TextField className="division-show-item" label="Назва Аптеки" source="name"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Тип закладу"}/>
                            <SelectField className="division-show-item" label="Тип закладу" source="type" choices={[
                                        {id: 'DRUGSTORE', name: 'Аптека'},
                                        {id: 'DRUGSTORE_POINT', name: 'Аптечний пункт'},
                                        {id: 'AMBULANT_CLINIC', name: 'Амбулаторія'},
                                        {id: 'CLINIC', name: 'Філія (інший відокремлений підрозділ)'},
                                        {id: 'FAP', name: 'ФАП'},
                                        {id: 'LICENSED_UNIT', name: 'Місце провадження діяльності'}
                                    ]}/>
                    </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"E-mail"}/>
                                    <TextField className="division-show-item" label="E-mail" source="email"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Верифікований з Реєстром ДЛС"}/>
                                    <SelectField className="division-show-item" label="Верифікований з Реєстром ДЛС" source="dlsVerified" choices={[
                                        {id: true, name: 'верифікований з Реєстром ДЛС'},
                                        {id: false, name: 'неверифікований з Реєстром ДЛС'},
                                        {id: null, name: 'неверифікований з Реєстром ДЛС'}
                                        // {id: null, name: 'невідоме значення'}
                                    ]}/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Ідентифікатор підрозділу в Реєстрі ДЛС"}/>
                            <FunctionField
                                render={record => record.dlsVerified !== true ? (<span style={{padding: '1em', color: 'red'}}>
                                    Відпуск ліків по даному підрозділу заборонено! Інформація по внесенному підрозділу не співпадає з
                                    інформацією в Реєстрі ДЛС. Для відпуску лікарських засобів у даному підрозділу просимо скорегувати дані
                                    згідно Реєстру ДЛС. <a href={"#/divisions/" + record.id}>Скорегувати данні</a>
                                </span>) : record.dlsId}
                            />
                        </CardContent>
                    </Card>
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Адреса</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Область"}/>
                            <TextField className="division-show-item" label="Область" source="area"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Район"}/>
                            <TextField className="division-show-item" label="Район" source="region"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Населенний пункт"}/>
                            <TextField className="division-show-item" label="Населенний пункт" source="settlement"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Тип населеного пункту"}/>
                            <SelectField className="division-show-item" label="Тип населеного пункту" source="settlementType" choices={[
                                {id: 'CITY', name: 'місто'},
                                {id: 'SETTLEMENT', name: 'селище'},
                                {id: 'TOWNSHIP', name: 'селище міського типу'},
                                {id: 'VILLAGE', name: 'село'}
                            ]}/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Назва вулиці"}/>
                            <TextField className="division-show-item" label="Назва вулиці" source="street"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Тип вулиці"}/>
                            <SelectField className="division-show-item" label="Тип вулиці" source="streetType" choices={streetTypes}/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Будинок"}/>
                            <TextField className="division-show-item" label="Будинок" source="building"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Кабінет"}/>
                            <TextField className="division-show-item" label="Кабінет" source="apartment"/>
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Поштовий індекс"}/>
                            <TextField className="division-show-item" label="Поштовий індекс" source="zip"/>
                        </CardContent>
                    </Card>
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Телефони</Typography>
                        <CardContent style={rowStyle}>
                            <PhoneArrayField label="Телефони" source="phones"/>
                        </CardContent>
                    </Card>
                    <Card style={cardStyle}>
                        <Typography variant="h6" style={{marginBottom: '0.5em'}}>Години праці</Typography>
                        <CardContent style={rowStyle}>
                            <Label caption={"Понеділок"}/>
                            <FunctionField
                                render={record => getAllTimeHours(record.workingHoursMon)} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Вівторок"}/>
                            <FunctionField
                                render={record => getAllTimeHours(record.workingHoursTue)} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Середа"}/>
                            <FunctionField
                                render={record => getAllTimeHours(record.workingHoursWed)} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Четвер"}/>
                            <FunctionField
                                render={record => getAllTimeHours(record.workingHoursThu)} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"П'ятниця"}/>
                            <FunctionField
                                render={record => getAllTimeHours(record.workingHoursFri)} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Субота"}/>
                            <FunctionField
                                render={record => getAllTimeHoursWeekEnd(record.workingHoursSat)} />
                        </CardContent>
                        <CardContent style={rowStyle}>
                            <Label caption={"Неділя"}/>
                            <FunctionField
                                render={record => getAllTimeHoursWeekEnd(record.workingHoursSun)} />
                        </CardContent>
                    </Card>
                </div>
            </div>
        </Show>
    );
};

export default DivisionShow;
